import { css } from 'styled-components'

export default css`
  &.AutomationRules {
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
    min-height: 0;
    overflow-y: auto;

    > .SaasPromoOrContent {
      flex-shrink: 0;
    }

    .automation-rules-content {
      display: flex;
      flex: 1;
      flex-direction: column;
      align-items: center;
      width: 100%;
      min-height: 0;
    }
  }
`
